//@ts-check
import CommonPage from './Common';
export default CommonPage;